import React, { ReactElement } from 'react';
import { Loading, usePermissions } from 'react-admin';
import { Navigate } from 'react-router';
import { LOGIN_URL } from '../../core/constants/url.constants';
import { some } from '../../core/utils/collection-utils';
import { PrivilegeType } from '../../core/models/privilegeType';
import jwtManager from '../../providers/jwtManager';

type Props = {
  privileges: PrivilegeType[];
  redirectPath: string;
  children?: ReactElement | null;
};

export const ProtectedRoute = ({
  privileges = [],
  redirectPath = '/',
  children = null
}: Props) => {
  const { isLoading, permissions } = usePermissions();

  const token = jwtManager.getToken();

  if (!token) {
    return <Navigate to={LOGIN_URL} replace />;
  }

  if (isLoading) {
    return <Loading />;
  }

  if (!some(privileges, permissions)) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
